import React from 'react';
import {View} from 'react-native';

// TODO implement an alternative, can we do with CSS?
export const PdfView = ({
  children,
  ...rest
}: React.PropsWithChildren<object>) => <View {...rest}>{children}</View>;
